import { Injectable } from "@angular/core";

import { CustomerService } from "./customer.service";
import { ToggleService } from "./toggle.service";

import { CashierOfficeSectorEnum } from "../../core/enums/cashier-office-sector.enum";
import { PayrollFileValidityStatusEnum } from "../../core/enums/payroll-file-validity-status.enum";
import { ToggleEnum } from "../../core/enums/toggle.enum";

@Injectable({
  providedIn: "root",
})
export class ClientEducationalService {
  private doublePension: string;
  private listFileDocuments = [];
  private payerName: string;
  private payerNit: string;
  private sector: number;

  constructor(
    private customerService: CustomerService,
    private toggleService: ToggleService,
  ) {}

  getDoublePension() {
    return this.doublePension;
  }

  getListFileDocuments() {
    return this.listFileDocuments;
  }

  getPayerName() {
    return this.payerName;
  }

  getPayerNit() {
    return this.payerNit;
  }

  getSector() {
    return this.sector;
  }

  getToggleEducational() {
    return (
      this.toggleService.getToggleEnabledById(
        ToggleEnum.NEW_CLIENT_EDUCATIONAL_SECTOR_TOGGLE,
      ) &&
      !this.toggleService.getToggleEnabledById(
        ToggleEnum.REQUEST_WORK_CERTIFICATE_EDUCATIONAL_SECTOR,
      ) &&
      this.customerService.isNewLoanDecision()
    );
  }

  getToggleOptimization() {
    return this.toggleService.getToggleEnabledById(
      ToggleEnum.PAYROLL_CHECK_OPTIMIZATION_II,
    );
  }

  isEducationalSector() {
    return (
      this.getToggleEducational() &&
      this.getSector() === CashierOfficeSectorEnum.EDUCATIONAL
    );
  }

  setDoublePension(doublePension: string) {
    this.doublePension = doublePension;
  }

  setListFileDocuments(documents: any[]) {
    for (const document of documents) {
      this.listFileDocuments.push({
        preloaded: document.status === PayrollFileValidityStatusEnum.OK,
        document: document,
      });
    }
  }

  setPayerName(payerName: string) {
    this.payerName = payerName;
  }

  setPayerNit(payerNit: string) {
    this.payerNit = payerNit;
  }

  setSector(sector: number) {
    this.sector = sector;
  }
}
